(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talanos-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    /* ── copy-link button ────────────────────────────────────────── */
    document.querySelectorAll('.ta-share-copy').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy-url');
        if (!url) return;
        navigator.clipboard.writeText(url).then(function () {
          var originalHTML = btn.innerHTML;
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M5 12l5 5L20 7"/></svg>';
          btn.style.background = '#d8e710';
          btn.style.borderColor = '#d8e710';
          btn.style.color = '#001b3d';
          setTimeout(function () {
            btn.innerHTML = originalHTML;
            btn.style.background = '';
            btn.style.borderColor = '';
            btn.style.color = '';
          }, 1800);
        });
      });
    });

    /* ── contents rail, built from the article's own H2s ─────────── */
    document.querySelectorAll('.talanos-article').forEach(function (root) {
      var content = root.querySelector('[data-ta-content]');
      var sidebar = root.querySelector('[data-ta-sidebar]');
      var list    = root.querySelector('[data-ta-toc-list]');
      var grid    = root.querySelector('[data-ta-grid]');
      if (!content || !sidebar || !grid) return;

      var hasOtherWidgets = !!sidebar.querySelector('.ta-expert-card');
      var headings = list ? Array.prototype.slice.call(content.querySelectorAll('h2')) : [];

      /* fewer than two sections isn't worth a contents list */
      if (headings.length < 2) {
        if (list && list.parentNode) list.parentNode.remove();
        if (!hasOtherWidgets) {
          grid.classList.add('is-railless');
          return;
        }
        sidebar.hidden = false;
        return;
      }

      var used = {};
      var links = [];

      headings.forEach(function (h) {
        var text = (h.textContent || '').trim();
        if (!text) return;

        if (!h.id) {
          var base = text.toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-')
            .slice(0, 60) || 'section';
          var slug = base;
          var n = 2;
          while (used[slug] || document.getElementById(slug)) {
            slug = base + '-' + n++;
          }
          h.id = slug;
        }
        used[h.id] = true;

        var li = document.createElement('li');
        var a  = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = text;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + h.id);
        });
        li.appendChild(a);
        list.appendChild(li);
        links.push({ heading: h, link: a });
      });

      if (!links.length) {
        grid.classList.add('is-railless');
        return;
      }

      sidebar.hidden = false;

      /* ── active-section highlight ──────────────────────────────── */
      var ticking = false;

      function setActive() {
        ticking = false;
        var marker = window.scrollY + 140;
        var current = links[0];

        for (var i = 0; i < links.length; i++) {
          if (links[i].heading.getBoundingClientRect().top + window.scrollY <= marker) {
            current = links[i];
          } else {
            break;
          }
        }

        /* past the end of the article, keep the last item lit */
        var end = content.getBoundingClientRect().bottom + window.scrollY;
        if (window.scrollY + window.innerHeight >= end + 80) {
          current = links[links.length - 1];
        }

        links.forEach(function (item) {
          item.link.classList.toggle('is-active', item === current);
        });
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(setActive);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      setActive();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
